/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ContractsIcon = createIcon("ContractsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 5-5-5H5a2 2 0 00-2 2v20a2 2 0 002 2h14a2 2 0 002-2V5Z",
    fill: "#23AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4 21.2-.6-.8.4-.3a4.73 4.73 0 00.478-.42C6.28 19.13 6 18.505 6 18c0-1.141.91-2 1.5-2 .58 0 1.5.407 1.5 1.5 0 .637-.442 1.46-.993 2.172.204.19.39.317.498.328.11-.078.414-.696.56-.993.3-.606.497-1.007.935-1.007.513 0 .672.532.875 1.205.06.2.158.529.245.726.367-.248 1.294-1.064 2.03-1.787l.356-.351.701.712-.356.351C11.674 21 11.167 21 11 21c-.621 0-.844-.713-1.074-1.477C9.577 20.231 9.176 21 8.5 21c-.348 0-.764-.229-1.155-.578a5.261 5.261 0 01-.545.478l-.4.3ZM7.5 17c-.266.085-.5.39-.5 1 0 .256.145.577.348.887.382-.53.652-1.068.652-1.387 0-.476-.332-.553-.5-.5Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0v3a2 2 0 002 2h3l-5-5Z",
    fill: "#2071C5"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: "11",
    y: "14",
    width: "7",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: "11",
    y: "8",
    width: "7",
    height: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: "6",
    y: "11",
    width: "12",
    height: "1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFC06D",
    points: "11 5.3333334 8.8948085 4.98324105 8 3 7.1051915 4.98324105 5 5.3333334 6.55742645 6.8216658 5.9813588 9 7.99995995 7.9311408 8 7.93117972 8.00004005 7.9311408 10.0186412 9 9.44257355 6.8216658"
  })));
}, {});